import React, { useContext, useEffect, useState } from "react";
import "../../Dashboard/View_List/View_List.css";
// import Add from "./Add";
// import Edit from "./Edit";
import Delete_Points_Modal from "../../Common_Component/Common_Modal/Delete_Points_Modal/Delete_Points_Modal";
import { Button, Form, Table } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare, faTrash } from "@fortawesome/free-solid-svg-icons";
import { findAll } from "../../../utils/apis/matka/bidCutting/bid_cutting";

import {
  formatDateTime,
  Per_Page_Dropdown,
  users_type,
} from "../../../utils/common";
import Pagination_holder from "../../Common_Component/Pagination_holder/Pagination_holder";
import CustomPaginate from "../../Common_Component/CustomPaginate/CustomPaginate";
import { Context } from "../../../utils/context";
import { Country, State, stores } from "../../../utils/apis/common/index";
import { formatDate } from "../../../utils/common";
import Select from "react-select";
import Heading_Holder from "../../Common_Component/Heading_Holder/Heading_Holder";

const Tables = () => {
  const params = new URLSearchParams(window.location.search);

  const id = params.get("id");
  const from = params.get("from");
  const store_id = params.get("store_id");
  const only_win = params.get("only_win") === "true";
  const typeParam = params.get("type");

  const { UnauthorizedLogOut, Select2Data, IMG_URL, usertype } =
    useContext(Context);

  const today = new Date();

  const formattedDate =
    today.getFullYear().toString() +
    String(today.getMonth() + 1).padStart(2, "0") +
    String(today.getDate()).padStart(2, "0");

  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setperPage] = useState(50);
  const [reset, setReset] = useState();

  const [name, setName] = useState("");
  const [contact_no, setContact_no] = useState("");
  const [store, setStore] = useState();

  const [searchDateFrom, setSearchDatefrom] = useState(from || "");
  const [onlyWin, setOnlyWin] = useState(only_win);
  const [type, setSearchType] = useState(typeParam || "");
  const [searchStore, setSearchStore] = useState(null);

  const getStores = async () => {
    const response = await stores();

    await setStore(response?.data?.data?.data);
  };

  const getDataAll = async () => {
    try {
      if (searchStore) {
        const response = await findAll(
          currentPage,
          perPage,
          searchDateFrom,
          searchStore?.value,
          type,
        );

        await setData(response?.data?.data);
      }
    } catch (error) {
      console.error(error.message);
      await UnauthorizedLogOut(error);
    }
  };

  useEffect(() => {
    getStores();
  }, []);

  useEffect(() => {
    if (store) {
      getDataAll();
    }
  }, [store, currentPage, perPage, reset]);

  const formatDateForPeriod = (date) => date.replaceAll("-", "");

  const sessionOptions = [
    { value: "", label: "Select Session" },
    { value: "open", label: "Open" },
    { value: "close", label: "Close" },
  ];

  useEffect(() => {
    if (store && store_id) {
      const selectedStore = store.find(
        (item) => String(item.value) === String(store_id),
      );

      setSearchStore(selectedStore || null);
    }
  }, [store, store_id]);

  const GameSection = ({
    title,
    rows = [],
    totalAmount,
    totalBids,
    winningAmount,
    predictGameId,
    copyData,
    isSangam = false,
  }) => {
    const sortedRows = [...rows].sort(
      (a, b) => Number(b?.win_amount || 0) - Number(a?.win_amount || 0),
    );

    return (
      <div className="card mt-3">
        <div className="card-header d-flex justify-content-between align-items-center">
          <strong>{title}</strong>

          <Button
            type="button"
            size="sm"
            variant="primary"
            onClick={() => {
              navigator.clipboard.writeText(copyData || "");
            }}>
            Copy {title} Data
          </Button>
        </div>

        <div className="card-body">
          <SummaryCard
            title={title}
            totalAmount={totalAmount}
            totalBids={totalBids}
            winningAmount={winningAmount}
          />

          <div className="table-responsive mt-3">
            <Table bordered striped>
              <thead>
                <tr>
                  <th>Digit</th>
                  <th>Total Bids</th>
                  <th>Total Amount</th>
                  <th>Winning Amount</th>
                  <th>Predicted Winning</th>
                  <th>Profit</th>
                  <th>Loss</th>
                </tr>
              </thead>

              <tbody>
                {sortedRows.map((row, index) => {
                  const total = Number(row?.total_amount || 0);
                  const win = Number(row?.win_amount || 0);

                  const pnl = win - total;

                  let digit = row?.bit_place;

                  return (
                    <tr key={row?.id || index}>
                      <td>{digit}</td>

                      <td>
                        <Button
                          variant="link"
                          className="p-0"
                          onClick={() => {
                            console.log("View bids:", row);
                          }}>
                          View
                        </Button>
                      </td>

                      <td>₹{total}</td>

                      <td>₹{win}</td>

                      <td>₹{row?.predict_win_amount}</td>

                      <td>₹{pnl < 0 ? Math.abs(pnl) : 0}</td>

                      <td>₹{pnl > 0 ? pnl : 0}</td>
                    </tr>
                  );
                })}

                {sortedRows.length === 0 && (
                  <tr>
                    <td colSpan="7" className="text-center">
                      No data found
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        </div>
      </div>
    );
  };

  const SummaryCard = ({ title, totalAmount, totalBids, winningAmount }) => {
    const profit = Number(totalAmount || 0) - Number(winningAmount || 0);

    return (
      <div className="card mt-3">
        <div className="card-body">
          <div className="row mb-3">
            <div className="col-md-4">
              <div className="p-3 bg-info text-white rounded">
                <h6>Total Amount</h6>

                <div className="d-flex align-items-center">
                  <h4>₹{totalAmount || 0}</h4>

                  <sub className="mt-2 ms-2">
                    (Total Bids - {totalBids || 0})
                  </sub>
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <div className="p-3 bg-warning text-dark rounded">
                <h6>Winning Amount</h6>
                <h4>₹{winningAmount || 0}</h4>
              </div>
            </div>

            <div className="col-md-4">
              <div className="p-3 bg-danger text-white rounded">
                <h6>Total Profit</h6>
                <h4>₹{profit}</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const predictWinReact = (gameId, amount) => {
    // Put the same calculation here that your Laravel predictWin()
    // function performs.

    return 0;
  };

  return (
    <>
      <section className="View_List">
        <Heading_Holder headingText={"Matka Bid Cutting"} />
        <div className="">
          <Form>
            <div className="row align-items-end">
              <div className="col-xxl-2 col-xl-3 col-lg-3 col-md-4 col-sm-5">
                <Form.Group className="form-field">
                  <Form.Label className="formlbb">Date</Form.Label>
                  <Form.Control
                    type="date"
                    value={searchDateFrom}
                    min="0001-01-01"
                    max="9999-12-31" // ✅ ensures only 4-digit year
                    onChange={(e) => {
                      const value = e.target.value;

                      // optional safety (can even remove this) 77777777777777777
                      if (!value) return;

                      const year = value.split("-")[0];
                      if (year.length !== 4) return;

                      setSearchDatefrom(value);
                    }}
                  />
                </Form.Group>
              </div>

              <div className="col-xxl-2 col-xl-3 col-lg-3 col-md-4 col-sm-5">
                <Form.Group className="form-field">
                  <Form.Label className="formlbb">Session</Form.Label>

                  <Select
                    isSearchable={false}
                    options={sessionOptions}
                    value={sessionOptions.find(
                      (option) => option.value === type,
                    )}
                    placeholder="Select Session"
                    onChange={(selected) =>
                      setSearchType(selected ? selected.value : "")
                    }
                  />
                </Form.Group>
              </div>

              <div className="col-xxl-2 col-xl-3 col-lg-3 col-md-4 col-sm-5">
                <Form.Group className="form-field">
                  <Form.Label className="formlbb">Store</Form.Label>

                  <Select
                    isSearchable
                    options={store}
                    value={searchStore}
                    placeholder="Select Store"
                    onChange={(e) => {
                      setSearchStore(e);
                    }}
                  />
                </Form.Group>
              </div>

              <div className="col-xxl-2 col-xl-3 col-lg-3 col-md-4 col-sm-5  col-holder">
                <br></br>
                <Button
                  type="button"
                  className="search-btn mt-2 btn-success"
                  onClick={getDataAll}>
                  Search
                </Button>
              </div>

              <div className="col-xxl-2 col-xl-3 col-lg-3 col-md-4 col-sm-5   col-holder">
                <br></br>
                <Button
                  type="button"
                  className="reset-btn mt-2 btn-danger "
                  onClick={() => {
                    setSearchDatefrom("");
                    setSearchStore("");
                    setSearchType("");
                    setReset(!reset);
                  }}>
                  Reset
                </Button>
              </div>
              <hr />
            </div>
          </Form>
        </div>

        <div className="table-responsive">
          {/* OVERALL SUMMARY */}
          <div className="card mt-3">
            <div className="card-header d-flex justify-content-between align-items-center">
              <strong>Overall Summary</strong>

              <Button
                type="button"
                size="sm"
                variant="primary"
                onClick={() => {
                  navigator.clipboard.writeText(data?.all_copy || "");
                }}>
                Copy All Data
              </Button>
            </div>

            <SummaryCard
              totalAmount={data?.total_summary_bet_amount}
              totalBids={data?.total_summary_bet}
              winningAmount={data?.total_summary_win_amount}
            />
          </div>

          {/* SINGLE DIGIT */}
          {data?.total_summary_bet_amount && (
            <GameSection
              title="Single Digit"
              rows={data?.single_bits}
              totalAmount={data?.single_ank_total}
              totalBids={data?.single_ank_total_bits}
              winningAmount={data?.single_digit_win_amount}
              predictGameId={1}
              copyData={data?.single_ank_copy}
            />
          )}

          {/* SINGLE PANA */}
          {data?.total_summary_bet_amount && (
            <GameSection
              title="Single Pana"
              rows={data?.single_pannas}
              totalAmount={data?.single_pana_total}
              totalBids={data?.single_pana_total_bits}
              winningAmount={data?.single_pana_win_amount}
              predictGameId={5}
              copyData={data?.single_pana_copy}
            />
          )}

          {/* DOUBLE PANA */}
          {data?.total_summary_bet_amount && (
            <GameSection
              title="Double Pana"
              rows={data?.double_pannas}
              totalAmount={data?.double_pana_total}
              totalBids={data?.double_pana_total_bits}
              winningAmount={data?.double_pana_win_amount}
              predictGameId={5}
              copyData={data?.double_pana_copy}
            />
          )}

          {/* TRIPLE PANA */}
          {data?.total_summary_bet_amount && (
            <GameSection
              title="Triple Pana"
              rows={data?.triple_pannas}
              totalAmount={data?.triple_pana_total}
              totalBids={data?.triple_pana_total_bits}
              winningAmount={data?.triple_pana_win_amount}
              predictGameId={5}
              copyData={data?.triple_pana_copy}
            />
          )}

          {/* JODI */}
          {type === "open" && data?.total_summary_bet_amount && (
            <GameSection
              title="Jodi"
              rows={data?.jodi_bits}
              totalAmount={data?.jodi_total}
              totalBids={data?.jodi_total_bits}
              winningAmount={data?.jodi_win_amount}
              predictGameId={5}
              copyData={data?.jodi_copy}
            />
          )}

          {/* HALF SANGAM */}
          {type === "open" && data?.total_summary_bet_amount && (
            <GameSection
              title="Half Sangam"
              rows={data?.half_sangam}
              totalAmount={data?.half_sangam_total}
              totalBids={data?.half_sangam_total_bits}
              winningAmount={data?.half_sangam_win_amount}
              predictGameId={5}
              copyData={data?.half_sangam_copy}
              isSangam
            />
          )}

          {/* FULL SANGAM */}
          {type === "open" && data?.total_summary_bet_amount && (
            <GameSection
              title="Full Sangam"
              rows={data?.full_sangam}
              totalAmount={data?.full_sangam_total}
              totalBids={data?.full_sangam_total_bits}
              winningAmount={data?.full_sangam_win_amount}
              predictGameId={5}
              copyData={data?.full_sangam_copy}
              isSangam
            />
          )}
        </div>
      </section>
    </>
  );
};
export default Tables;
